import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurtaxi() {



    const cardData = {




keyword: "Mumbai to Jaipur Taxi",

headingDescription: "Shreesha Tours & Travels offers reliable, safe, and affordable Mumbai to Jaipur taxi services for families, business travelers, tourists, corporate clients, students, and long-distance travelers. We provide one-way cabs, round-trip taxi services, airport transfers, multi-city journeys, Rajasthan tour packages, and customized outstation travel solutions with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, instant booking assistance, and 24/7 customer support, Shreesha Tours & Travels ensures a comfortable, safe, and hassle-free road journey. Whether you are traveling for business meetings, destination weddings, family vacations, educational tours, cultural exploration, or sightseeing, our Mumbai to Jaipur taxi service provides professional drivers, clean vehicles, and personalized travel solutions. Enjoy a memorable journey with flexible stopovers, premium travel comfort, and dependable service while exploring the royal heritage and colorful culture of Rajasthan.",

topPlaces: [
  {
    title: "Hawa Mahal",
    description: "Hawa Mahal, also known as the Palace of Winds, is Jaipur's most iconic landmark featuring its magnificent pink sandstone façade with 953 beautifully designed windows. Built for the royal women of Jaipur, it is a masterpiece of Rajput architecture and a must-visit attraction for every traveler."
  },
  {
    title: "Amber Fort",
    description: "Amber Fort is a UNESCO World Heritage Site and one of Rajasthan's grandest forts. Famous for its magnificent palaces, Sheesh Mahal, artistic courtyards, elephant rides, and breathtaking hilltop views, it attracts visitors from around the world."
  },
  {
    title: "City Palace",
    description: "City Palace is a magnificent royal residence located in the heart of Jaipur. The palace complex features beautiful courtyards, museums, royal costumes, weapons, art galleries, and elegant architecture reflecting the rich heritage of Rajasthan."
  },
  {
    title: "Jantar Mantar",
    description: "Jantar Mantar is a UNESCO World Heritage Site featuring the world's largest stone sundial and a remarkable collection of astronomical instruments. It showcases the scientific achievements of Maharaja Sawai Jai Singh II and is one of Jaipur's most popular historical attractions."
  },
  {
    title: "Nahargarh Fort",
    description: "Nahargarh Fort offers spectacular panoramic views of Jaipur city and the surrounding Aravalli Hills. It is a favorite destination for sunset lovers, photographers, and history enthusiasts exploring Rajasthan's royal heritage."
  },
  {
    title: "Jal Mahal",
    description: "Jal Mahal is a stunning palace situated in the middle of Man Sagar Lake. Surrounded by peaceful waters and beautiful landscapes, it is one of Jaipur's most photographed landmarks and a favorite stop for sightseeing."
  },
  {
    title: "Albert Hall Museum",
    description: "Albert Hall Museum is Rajasthan's oldest museum and houses an impressive collection of paintings, sculptures, ancient artifacts, textiles, coins, and historical exhibits. Its Indo-Saracenic architecture makes it a major cultural attraction."
  },
  {
    title: "Birla Mandir",
    description: "Birla Mandir, dedicated to Lord Vishnu and Goddess Lakshmi, is a beautiful white marble temple known for its peaceful atmosphere, intricate carvings, and elegant architecture. It is one of Jaipur's most visited spiritual destinations."
  },
  {
    title: "Patrika Gate",
    description: "Patrika Gate is one of Jaipur's most colorful and Instagram-worthy attractions. The beautifully painted corridors showcase Rajasthan's rich culture, traditions, architecture, and artistic heritage, making it a favorite destination for photography."
  },
  {
    title: "Chokhi Dhani",
    description: "Chokhi Dhani is a famous ethnic village resort that offers an authentic Rajasthani cultural experience with traditional folk dances, puppet shows, camel rides, local handicrafts, and delicious Rajasthani cuisine. It is a perfect destination for families and tourists wanting to experience Rajasthan's vibrant culture."
  }
],



"services": [
  {
    "name": "Mumbai to Jaipur Taxi",
    "description": "Book Mumbai to Jaipur Taxi for safe, comfortable, and reliable long-distance travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for family vacations, corporate travel, business meetings, holiday tours, and one way or round trip journeys. Enjoy doorstep pickup, transparent pricing, and 24x7 customer support for a hassle-free interstate journey."
  },
  {
    "name": "Mumbai to Jaipur Cab",
    "description": "Hire Mumbai to Jaipur Cab for convenient interstate travel with professional drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven cabs are perfect for family trips, corporate travel, personal journeys, sightseeing, and comfortable road travel between Mumbai and Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Taxi Service",
    "description": "Choose Mumbai to Jaipur Taxi Service for dependable outstation transportation with premium AC vehicles, trained chauffeurs, and flexible booking options. Enjoy reliable travel for business visits, vacations, family functions, and long-distance journeys."
  },
  {
    "name": "Mumbai to Jaipur Cab Service",
    "description": "Book Mumbai to Jaipur Cab Service for smooth and comfortable travel with experienced drivers, transparent fares, and multiple vehicle choices. Travel safely with one way and round trip cab services available throughout the year."
  },
  {
    "name": "Mumbai to Jaipur Taxi Fare",
    "description": "Check Mumbai to Jaipur Taxi Fare with transparent pricing and affordable travel packages. Compare Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options to choose the best vehicle for your journey."
  },
  {
    "name": "Mumbai to Jaipur Cab Fare",
    "description": "Get the best Mumbai to Jaipur Cab Fare with competitive pricing, professional chauffeur service, and premium AC vehicles. Enjoy safe, economical, and comfortable interstate transportation without hidden charges."
  },
  {
    "name": "Mumbai to Jaipur Cab Booking",
    "description": "Complete Mumbai to Jaipur Cab Booking online with instant confirmation, affordable pricing, and multiple vehicle options. Select the ideal cab according to your travel needs and enjoy convenient doorstep pickup."
  },
  {
    "name": "Mumbai to Jaipur Car Rental",
    "description": "Hire Mumbai to Jaipur Car Rental with chauffeur-driven vehicles for flexible travel plans and comfortable interstate journeys. Suitable for family holidays, business tours, corporate travel, and personal trips."
  },
  {
    "name": "Mumbai to Jaipur One Way Taxi",
    "description": "Book Mumbai to Jaipur One Way Taxi for affordable single-trip travel without paying return charges. Enjoy fixed fares, experienced chauffeurs, clean vehicles, and reliable long-distance transportation."
  },
  {
    "name": "Mumbai to Jaipur Round Trip Cab",
    "description": "Reserve Mumbai to Jaipur Round Trip Cab for comfortable return journeys with flexible schedules and budget-friendly packages. Perfect for business travel, family vacations, weddings, and sightseeing tours."
  },
  {
    "name": "Mumbai Airport to Jaipur Taxi",
    "description": "Book Mumbai Airport to Jaipur Taxi for reliable airport pickup and direct interstate travel with professional chauffeurs and comfortable AC vehicles. Enjoy timely pickup from all Mumbai airport terminals."
  },
  {
    "name": "Mumbai Airport to Jaipur Cab",
    "description": "Choose Mumbai Airport to Jaipur Cab for hassle-free airport transfers with experienced drivers, premium vehicles, and convenient pickup services. Travel safely from Mumbai Airport directly to Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Outstation Cab",
    "description": "Hire Mumbai to Jaipur Outstation Cab for safe and comfortable interstate travel with clean AC vehicles, skilled chauffeurs, transparent pricing, and flexible one way or round trip packages."
  },
  {
    "name": "Mumbai to Jaipur Private Taxi",
    "description": "Reserve Mumbai to Jaipur Private Taxi for personalized travel with dedicated chauffeur-driven vehicles, premium comfort, flexible schedules, and complete privacy throughout your journey."
  },
  {
    "name": "Mumbai to Jaipur Car Hire",
    "description": "Choose Mumbai to Jaipur Car Hire for private chauffeur-driven transportation with spacious vehicles, experienced drivers, and dependable customer support. Perfect for business executives, families, and tourists."
  },
  {
    "name": "Navi Mumbai to Jaipur Cab",
    "description": "Book Navi Mumbai to Jaipur Cab for reliable interstate travel with premium AC vehicles, professional chauffeurs, and affordable pricing. Ideal for business travel, vacations, and personal journeys."
  },
  {
    "name": "Thane to Jaipur Taxi",
    "description": "Choose Thane to Jaipur Taxi for dependable long-distance transportation with clean vehicles, experienced drivers, and transparent pricing. Enjoy a smooth and relaxing journey from Thane to Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Innova Cab",
    "description": "Hire Mumbai to Jaipur Innova Cab for spacious and comfortable travel with ample luggage space, premium seating, and experienced chauffeurs. Perfect for families, corporate teams, and group travel."
  },
  {
    "name": "Mumbai to Jaipur Innova Crysta Cab",
    "description": "Book Mumbai to Jaipur Innova Crysta Cab for luxury interstate travel with premium interiors, spacious seating, advanced comfort, and professional chauffeur service. Ideal for executive travel and family vacations."
  },
  {
    "name": "Mumbai to Jaipur Ertiga Cab",
    "description": "Reserve Mumbai to Jaipur Ertiga Cab for affordable 6 to 7 seater travel with comfortable seating, spacious interiors, and reliable chauffeur service. Suitable for family tours and group journeys."
  },
  {
    "name": "Mumbai to Jaipur Sedan Cab",
    "description": "Choose Mumbai to Jaipur Sedan Cab for economical travel with clean AC vehicles, professional drivers, and comfortable seating. Perfect for solo travelers, couples, and business executives."
  },
  {
    "name": "Mumbai to Jaipur SUV Cab",
    "description": "Book Mumbai to Jaipur SUV Cab for premium long-distance travel with spacious seating, extra luggage capacity, and comfortable interiors. Ideal for families, luxury travel, and road trips."
  },
  {
    "name": "Mumbai to Jaipur Tempo Traveller",
    "description": "Reserve Mumbai to Jaipur Tempo Traveller for group tours, corporate outings, family vacations, pilgrimage trips, and event travel. Enjoy spacious seating, experienced chauffeurs, and comfortable interstate transportation."
  },
  {
    "name": "Mumbai to Jaipur Tourist Cab",
    "description": "Book Mumbai to Jaipur Tourist Cab for sightseeing tours, holiday packages, family vacations, and Rajasthan travel. Enjoy flexible itineraries, premium vehicles, and experienced drivers for a memorable journey."
  },
  {
    "name": "Reliable Mumbai Jaipur Taxi Service",
    "description": "Choose Reliable Mumbai Jaipur Taxi Service for trusted chauffeur-driven transportation with well-maintained AC vehicles, transparent pricing, and 24x7 customer support. Experience safe, punctual, and comfortable one way or round trip travel for business, family, and leisure journeys."
  }
],
"tableData": [
  ["Mumbai to Jaipur Taxi", "Mumbai to Jaipur Cab"],
  ["Mumbai to Jaipur Taxi Service", "Mumbai to Jaipur Cab Service"],
  ["Mumbai to Jaipur Taxi Fare", "Mumbai to Jaipur Cab Fare"],
  ["Mumbai to Jaipur Cab Booking", "Mumbai to Jaipur Car Rental"],
  ["Mumbai to Jaipur One Way Taxi", "Mumbai to Jaipur Round Trip Cab"],
  ["Mumbai Airport to Jaipur Taxi", "Mumbai Airport to Jaipur Cab"],
  ["Mumbai to Jaipur Outstation Cab", "Mumbai to Jaipur Private Taxi"],
  ["Mumbai to Jaipur Car Hire", "Navi Mumbai to Jaipur Cab"],
  ["Thane to Jaipur Taxi", "Mumbai to Jaipur Innova Cab"],
  ["Mumbai to Jaipur Innova Crysta Cab", "Mumbai to Jaipur Ertiga Cab"],
  ["Mumbai to Jaipur Sedan Cab", "Mumbai to Jaipur SUV Cab"],
  ["Mumbai to Jaipur Tempo Traveller", "Mumbai to Jaipur Tourist Cab"],
  ["Reliable Mumbai Jaipur Taxi Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Luxury Mumbai to Jaipur Taxi for Memorable Road Trips",
    WhyChoosedescription: "Discover a comfortable way to travel from Mumbai to Jaipur with Shreesha Tours & Travels. Our private taxi service is perfect for tourists, business travellers, families, and groups seeking a safe and enjoyable interstate journey."
  },
  {
    WhyChooseheading: "Travel on Your Schedule Without Rush",
    WhyChoosedescription: "Enjoy complete flexibility by choosing your own departure time, preferred pickup point, meal breaks, and optional stopovers while travelling from Mumbai to Jaipur."
  },
  {
    WhyChooseheading: "Modern Fleet for Long-Distance Comfort",
    WhyChoosedescription: "Book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, or luxury cars that provide excellent comfort for extended highway journeys."
  },
  {
    WhyChooseheading: "Perfect for Rajasthan Holidays & Business Visits",
    WhyChoosedescription: "Whether you're visiting Jaipur for sightseeing, destination weddings, business meetings, educational tours, family functions, or cultural events, our taxi service is tailored for every travel purpose."
  },
  {
    WhyChooseheading: "Experienced Interstate Chauffeurs",
    WhyChoosedescription: "Our professional drivers are skilled in handling long highway routes across multiple states, ensuring a secure, smooth, and punctual travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way, Round Trip & Multi-City Tours",
    WhyChoosedescription: "Choose one-way taxi service, round-trip booking, or extend your journey to destinations like Ajmer, Pushkar, Udaipur, Jodhpur, Ranthambore, or Mount Abu with customized travel plans."
  },
  {
    WhyChooseheading: "Clean Vehicles with Premium Travel Comfort",
    WhyChoosedescription: "Every vehicle is regularly maintained with spacious seating, air-conditioned interiors, and ample luggage capacity to keep your long-distance journey comfortable."
  },
  {
    WhyChooseheading: "Reliable Booking Support from Shreesha Tours & Travels",
    WhyChoosedescription: "Receive transparent fare details, quick booking assistance, and dedicated customer support to make your Mumbai to Jaipur taxi booking easy and convenient."
  }
]

};

const faqData = [
  {
    question: "Can I travel from Mumbai to Jaipur in a private taxi?",
    answer: "Yes, Shreesha Tours & Travels provides private Mumbai to Jaipur taxi services with doorstep pickup and direct drop anywhere in Jaipur."
  },
  {
    question: "Is this taxi service suitable for Rajasthan sightseeing tours?",
    answer: "Yes, you can customize your trip by including destinations such as Ajmer, Pushkar, Udaipur, Jodhpur, Ranthambore, Mount Abu, and other Rajasthan attractions."
  },
  {
    question: "Which vehicles are available for Mumbai to Jaipur travel?",
    answer: "Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles are available for every travel requirement."
  },
  {
    question: "Can I plan a multi-day road trip from Mumbai to Jaipur?",
    answer: "Yes, multi-day itineraries with overnight stays and sightseeing stopovers can be arranged according to your travel plans."
  },
  {
    question: "Do you provide cabs for destination weddings in Jaipur?",
    answer: "Yes, our taxi service is suitable for wedding guests, families, and destination wedding transportation."
  },
  {
    question: "Can I book a one-way Mumbai to Jaipur taxi?",
    answer: "Yes, one-way, round-trip, and customized interstate taxi services are available throughout the year."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and Navi Mumbai?",
    answer: "Yes, pickup is available from Mumbai Airport, Navi Mumbai, hotels, railway stations, offices, and residential locations."
  },
  {
    question: "Can Tempo Travellers be booked for group travel to Jaipur?",
    answer: "Yes, Tempo Travellers are available for family vacations, educational tours, wedding groups, and corporate travel."
  },
  {
    question: "How is the Mumbai to Jaipur taxi fare calculated?",
    answer: "The fare depends on the selected vehicle, trip duration, travel route, and any customized sightseeing or stopovers included in your itinerary."
  },
  {
    question: "What details are required for Mumbai to Jaipur taxi booking?",
    answer: "Share your travel date, pickup location, destination, passenger count, preferred vehicle, and travel plan to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Sharma",
    feedback: "Our Mumbai to Jaipur road trip was exceptionally comfortable. The Innova Crysta was in excellent condition, and the driver managed the long journey professionally with planned breaks.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ruchi Singh",
    feedback: "We booked a taxi with Shreesha Tours & Travels for a family vacation in Jaipur. The booking process was smooth, the vehicle was spotless, and the entire trip exceeded our expectations.",
    rating: 5
  }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Taxi",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-jaipur-taxi.webp",
  "description":
    "Book Mumbai to Jaipur Taxi with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Jaipur with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, family vacations, heritage tours, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-jaipur-taxi"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Jaipur Taxi | Rajasthan Cab Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur Taxi with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Jaipur with 24x7 online cab booking and transparent fares."
  />

  <meta
    name="keywords"
    content="Mumbai to Jaipur Taxi, Mumbai to Jaipur Cab, Mumbai to Jaipur Taxi Service, Mumbai to Jaipur Cab Service, Mumbai to Jaipur Taxi Fare, Mumbai to Jaipur Cab Fare, Mumbai to Jaipur One Way Cab, Mumbai to Jaipur Round Trip Cab, Mumbai to Jaipur Taxi Booking, Mumbai to Jaipur Cab Booking, Mumbai to Jaipur Car Rental, Mumbai to Jaipur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitojaipurtaxi;